// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as tableListSelector from 'redux/selectors/tableList';
import { Row, Col } from 'antd';
import * as cartActions from 'redux/actions/cart';
import * as listActions from 'redux/actions/list';
import { toDateString, toPrice } from 'Utils/utils';
import { WrapperTable } from 'components';

const { Fragment } = React;

class AbandonedCartList extends Component {
  componentWillUnmount() {
    this.props.unload();
  }

  render() {
    return (
      <div>
        <Row>
          <Col span={24}>
            <WrapperTable
              title="Abandoned Carts"
              filters={filters}
              columns={columns}
              data={this.props.listData}
              api={this.props.searchCarts}
              defaultFilters={defaultFilters}
              tableAction={tableAction}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
const columns = [
  {
    title: 'Customer Name',
    dataIndex: 'customerName',
    sorter: true
  },
  {
    title: 'Status',
    dataIndex: 'status',
    sorter: true
  },
  {
    title: 'Product Count',
    dataIndex: 'productCount'
  },
  {
    title: 'Item Count',
    dataIndex: 'itemCount'
  },
  {
    title: 'Total Disc',
    dataIndex: 'totalDiscAmt',
    render: d => toPrice(d)
  },
  {
    title: 'Total',
    dataIndex: 'total',
    sorter: true,
    render: d => toPrice(d)
  },
  {
    title: 'Created On',
    dataIndex: 'createdOn',
    sorter: true,
    render: d => toDateString(d)
  },
  {
    title: 'Updated On',
    dataIndex: 'updatedOn',
    sorter: true,
    defaultSortOrder: 'descend',
    render: d => toDateString(d)
  }
];

const filters = [
  {
    field: 'customerName',
    type: 'TEXT'
  }
];

let tableAction = <Fragment></Fragment>;

const defaultFilters = {
  status: {
    _field: 'status',
    values: ['ACTIVE', 'CLEARED'],
    operator: 'IN'
  }
};

const mapDispatchToProps = {
  searchCarts: cartActions.searchCarts,
  unload: listActions.listUnload
};

const mapStateToProps = (state, props) => {
  return {
    listData: tableListSelector.listData(state)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AbandonedCartList);
